import Vue from 'vue';
import App from './App.vue';
import { getQuerystring, getHostName } from './helpers/HttpTools.js';

Vue.config.productionTip = false;

/**
 * Fonction d 'envoi de l' image a l 'outil Gestour Catalog
 *
 * @param {string} pHostName hostname de l'appelant (Gestour Catalog. Exple : dev.magnetic.coop)
 * @param {string} pSourceWindow référence vers la fenêtre appelante
 * @param {string} pImagePath chemin de l 'image sur la medialib (Exemple: https://medialib.gestour.w3b-experience.net/img/canada1.jpg)
 */
// function sendImageToCatalog(pHostName, pSourceWindow, pImagePath) {
const sendImageToCatalog = (pHostName, pSourceWindow, pImagePath) => {
  // console.log('sendImageToCatalog', pHostName, ', ', pSourceWindow, ', ', pImagePath);

  var imagename = pImagePath.replace(/^.*[\\\/]/, '');

  var json = {
    "name": imagename,
    "contentType": "image/jpeg",
    "url": pImagePath
  };

  console.log('[IFRAME] SEND : sendImageToCatalog : json = ' + JSON.stringify(json));

  //-- Envoie à la fenêtre appelante
  if (pHostName !== 'localhost')
  {
    var urlPrefix = ((pHostName !== 'boutique.rav.test' && pHostName !== 'dev.magnetic.coop') ? 'https://' : 'http://');
    pSourceWindow.postMessage(JSON.stringify(json), urlPrefix + pHostName);
  }else{
    alert('Test en local !\n[IFRAME] SEND : sendImageToCatalog : json = \n' + JSON.stringify(json))
  }
}


let mediagallery;

function launchApp() {
  //-- Options de l'app (fonction de post de l'image)
  const options = {
    sendImage: function (pUrlFull) {
      sendImageToCatalog(RAV_host_name, RAV_source_window, pUrlFull);
    },
    hostname: RAV_host_name
  }

  //-- instancie la Vue
  mediagallery = new Vue({
    events: {
      'imgselected': function (argument) {
        // logic
        console.log('imgselected => ', argument);
      },
    },
    render: h => h(App, {
      props: {
        options: options
      }
    })
  }).$mount('#app');
}

//-- Récupère la référence de la fenêtre appelante
let RAV_source_window;
if (window.parent) {
  RAV_source_window = window.parent;
  // console.log('[IFRAME] window.parent');
} else if (window.top) {
  RAV_source_window = window.top;
  console.log('[IFRAME] window.top');
}

//-- Recupère le hostname au format Gestour
let RAV_host_name = getHostName(decodeURIComponent(getQuerystring('host_name')));

if (RAV_source_window !== null && RAV_host_name !== null && RAV_host_name !== '') {
  // console.log('[IFRAME] RAV_source_window = '+RAV_source_window.location);
  // console.log('[IFRAME] RAV_host_name = ' + RAV_host_name);

  launchApp();
}else if(document.location.hostname === 'localhost') {
    RAV_host_name = 'localhost';
    console.log('[localhost] RAV_host_name = ' + RAV_host_name);

    launchApp();
} else {
  document.body.innerHTML = 'Erreur appel direct de la page hors Gestour Catalog !';
}